export enum RunStatus {
    SUCCESS = 'success',
    FAILED = 'failed',
}

export enum Status {
    DRAFT = 'DRAFT',
    READY = 'READY',
    CALCULATING = 'CALCULATING',
    SUCCESS = 'SUCCESS',
    FAIL = 'FAIL',
    MB_MODIFIED = 'MB-MODIFIED',
}

export enum EngineStatus {
    DRAFT = 'DRAFT',
    READY = 'READY',
    RUNNING = 'RUNNING',
}

export enum LastRunStatus {
    SUCCESS = 'success',
    FAILED = 'failed',
}

export enum Interval {
    RAW = 'raw',
    MINUTE = '1 minute',
    MINUTE_5 = '5 minute',
    MINUTE_15 = '15 minute',
    MINUTE_30 = '30 minute',
    HOUR = '1 hour',
    DAY = '1 day',
    WEEK = '1 week',
    MONTH = '1 month',
}

export enum InputType {
    VIRTUAL = 'VIRTUAL',
    PHYSICAL = 'PHYSICAL',
    CONSTANT = 'CONSTANT',
    SIMULATION = 'SIMULATION',
}
export enum TimeSeriesType {
    OPEN = 'OPEN',
    HIGH = 'HIGH',
    LOW = 'LOW',
    CLOSE = 'CLOSE',
    AVERAGE = 'AVERAGE',
    RAW = 'RAW',
}

export enum DataType {
    TIMESERIES = 'TimeSeries',
    STRING = 'string',
    NUMBER = 'number',
    INTEGER = 'integer',
    ANY = 'any',
}
